var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedAts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33334 8C1.33334 6.15906 2.82573 4.66667 4.66668 4.66667H6.66668C7.03487 4.66667 7.33334 4.96515 7.33334 5.33334C7.33334 5.70153 7.03487 6.00001 6.66668 6.00001H4.66668C3.56211 6.00001 2.66668 6.89544 2.66668 8C2.66668 9.10457 3.56211 10 4.66668 10H6.66668C7.03487 10 7.33334 10.2985 7.33334 10.6667C7.33334 11.0349 7.03487 11.3333 6.66668 11.3333H4.66668C2.82573 11.3333 1.33334 9.84095 1.33334 8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66666 5.33334C8.66666 4.96515 8.96513 4.66667 9.33332 4.66667H11.3333C13.1743 4.66667 14.6667 6.15906 14.6667 8C14.6667 9.84095 13.1743 11.3333 11.3333 11.3333H9.33332C8.96513 11.3333 8.66666 11.0349 8.66666 10.6667C8.66666 10.2985 8.96513 10 9.33332 10H11.3333C12.4379 10 13.3333 9.10457 13.3333 8C13.3333 6.89544 12.4379 6.00001 11.3333 6.00001H9.33332C8.96513 6.00001 8.66666 5.70153 8.66666 5.33334Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33331 7.99999C5.33331 7.63181 5.63179 7.33333 5.99998 7.33333H9.99998C10.3682 7.33333 10.6666 7.63181 10.6666 7.99999C10.6666 8.36818 10.3682 8.66666 9.99998 8.66666H5.99998C5.63179 8.66666 5.33331 8.36818 5.33331 7.99999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedAts);
export default __webpack_public_path__ + "static/media/linked-ats.51c844f837579388d3cd7309ebb9939c.svg";
export { ForwardRef as ReactComponent };